import { render, staticRenderFns } from "./marketing-scene-form.vue?vue&type=template&id=0afbf1c4&scoped=true"
import script from "./marketing-scene-form.vue?vue&type=script&setup=true&lang=js"
export * from "./marketing-scene-form.vue?vue&type=script&setup=true&lang=js"
import style0 from "./marketing-scene-form.vue?vue&type=style&index=0&id=0afbf1c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afbf1c4",
  null
  
)

export default component.exports